import { createFileRoute, notFound } from '@tanstack/react-router';
import { PayloadPreviewRefresh } from '~/components/payload/ArticlePreviewRefresh';
import { LegalDocument } from '~/components/sections/LegalDocument';
import { getLegalPagePreviewByID } from '~/lib/payload';
import readingStylesHref from '~/styles/reading.css?url';

export const Route = createFileRoute('/preview/legal-pages/$id')({
  loader: async ({ params }) => {
    const page = await getLegalPagePreviewByID({ data: params.id });
    if (!page) throw notFound();
    return { page };
  },
  head: ({ loaderData }) => ({
    meta: [
      { title: `Preview: ${loaderData?.page.title ?? 'Legal page'} – nsave` },
      { name: 'robots', content: 'noindex,nofollow,noarchive' },
    ],
    links: [{ rel: 'stylesheet', href: readingStylesHref }],
  }),
  component: LegalPagePreview,
});

function LegalPagePreview() {
  const { page } = Route.useLoaderData();
  return (
    <>
      <PayloadPreviewRefresh />
      <LegalDocument key={page.fullPath} page={page} />
    </>
  );
}
